'use client';

import { useDatong } from '@ssv-website/hooks';
import { useEffect } from 'react';
import dynamic from 'next/dynamic';

export const WXJSSDK = dynamic(
  () => import('./wx-js-sdk').then((mod) => mod.WXJSSDK),
  { ssr: false }
);
export const WXShare = dynamic(
  () => import('./wx-js-sdk').then((mod) => mod.WXShare),
  { ssr: false }
);
export const RumSDK = dynamic(() => import('./rum-sdk'), {
  ssr: false,
});

export function SDK() {
  useEffect(() => {
    // 开发环境才会出现
    if (process.env.APP_ENV === 'development') {
      import('vconsole').then((VConsole) => {
        new VConsole.default();
      });
    }
  }, []);
  useDatong();
  return (
    <>
      <RumSDK />
      <WXJSSDK />
    </>
  );
}
